import { CommonModule, NgOptimizedImage } from "@angular/common";
import { NgModule, LOCALE_ID } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { TippyDirective } from "@ngneat/helipopper";

import {
  AutoOpenMenuComponent,
  BulkAddSlideOverComponent,
  ButtonComponent,
  ButtonToggleComponent,
  LoaderComponent,
} from "@components/shared";
import { DropdownMenuComponent } from "@components/shared/dropdown/dropdown-menu/dropdown-menu.component";
import { DropdownMenuItemComponent } from "@components/shared/dropdown/dropdown-menu-item/dropdown-menu-item.component";
import { SlideOverlayPageComponent } from "@components/shared/overlay/slide-overlay-page/slide-overlay-page.component";
import { SlideOverlayWrapperComponent } from "@components/shared/overlay/slide-overlay-wrapper/slide-overlay-wrapper.component";
import { ShortcutAddMenuComponent } from "@components/shared/shorcut-add-menu/shortcut-add-menu.component";
import { SidebarDropdownComponent } from "@components/shared/sidebar/sidebar-dropdown/sidebar-dropdown.component";
import { SidebarGroupItemComponent } from "@components/shared/sidebar/sidebar-group-item/sidebar-group-item.component";
import { SidebarItemComponent } from "@components/shared/sidebar/sidebar-item/sidebar-item.component";
import { SidebarMenuComponent } from "@components/shared/sidebar/sidebar-menu/sidebar-menu.component";
import { UserAccountButtonComponent } from "@components/shared/user-account-button/user-account-button.component";
import { BackNavigationDirective } from "@shared/directives";
import { UnitConversionPipe } from "@shared/pipes";
import { LocalizationUtils } from "@shared/utils";

import { AppComponentAngularMaterialModule } from "./app-component-angular-material.module";

const appPipes = [UnitConversionPipe];

const components = [
  SlideOverlayPageComponent,
  BulkAddSlideOverComponent,
  SidebarMenuComponent,
  SidebarDropdownComponent,
  SidebarItemComponent,
  SidebarGroupItemComponent,
  UserAccountButtonComponent,
  DropdownMenuItemComponent,
  ButtonToggleComponent,
  DropdownMenuComponent,
  ShortcutAddMenuComponent,
  ButtonComponent,
  SlideOverlayWrapperComponent,
  BackNavigationDirective,
  ...appPipes,
];

const standaloneComponents = [AutoOpenMenuComponent, LoaderComponent];

const importExportModules = [
  CommonModule,
  ReactiveFormsModule,
  AppComponentAngularMaterialModule,
  RouterModule,
  NgOptimizedImage,
  TippyDirective,
];

@NgModule({
  declarations: [...components],
  imports: [...standaloneComponents, ...importExportModules],
  exports: [...components, ...standaloneComponents, ...importExportModules],
  providers: [
    ...appPipes,
    { provide: LOCALE_ID, useValue: LocalizationUtils.getLocaleForAngularConfig() },
  ],
})
export class AppComponentsModule {}
